/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Ukm_P1dInputs */

const en_mk_sol_ukm_p1d = /** @type {(inputs: Mk_Sol_Ukm_P1dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One person spends the first hour of every day copying five branches’ numbers into one place.`)
};

const id_mk_sol_ukm_p1d = /** @type {(inputs: Mk_Sol_Ukm_P1dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Satu orang menghabiskan satu jam pertama setiap hari menyalin angka lima cabang ke satu tempat.`)
};

/**
* | output |
* | --- |
* | "One person spends the first hour of every day copying five branches’ numbers into one place." |
*
* @param {Mk_Sol_Ukm_P1dInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_ukm_p1d = /** @type {((inputs?: Mk_Sol_Ukm_P1dInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Ukm_P1dInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_ukm_p1d(inputs)
	return en_mk_sol_ukm_p1d(inputs)
});